import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { WorkspaceAssetLifecyclePolicy } from '../../generated/fragments';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetProjectAssetLifecyclePolicyQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type GetProjectAssetLifecyclePolicyQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, project?: { __typename?: 'Project', id: string, ignoreArchive: boolean, workspace?: { __typename?: 'Workspace', id: string, daysBeforeAssetAutoDeletion?: number | null } | null } | null } | null };


export const GetProjectAssetLifecyclePolicy = /*#__PURE__*/ gql`
    query GetProjectAssetLifecyclePolicy($projectId: ID!) {
  account(by: {projectId: $projectId}) {
    id
    project(id: $projectId) {
      id
      ignoreArchive
      workspace {
        id
        ...WorkspaceAssetLifecyclePolicy
      }
    }
  }
}
    ${WorkspaceAssetLifecyclePolicy}` as unknown as DocumentNode<GetProjectAssetLifecyclePolicyQuery, GetProjectAssetLifecyclePolicyQueryVariables>;

          

          export const useGetProjectAssetLifecyclePolicyQuery = (options?:QueryHookOptions<GetProjectAssetLifecyclePolicyQuery, GetProjectAssetLifecyclePolicyQueryVariables>) => useQuery(GetProjectAssetLifecyclePolicy, options);

          

          export type GetProjectAssetLifecyclePolicyQueryOptions = QueryHookOptions<GetProjectAssetLifecyclePolicyQuery, GetProjectAssetLifecyclePolicyQueryVariables>;

          

          export const useGetProjectAssetLifecyclePolicyLazyQuery = (options?:LazyQueryHookOptions<GetProjectAssetLifecyclePolicyQuery, GetProjectAssetLifecyclePolicyQueryVariables>) => useLazyQuery(GetProjectAssetLifecyclePolicy, options);

          

          export type GetProjectAssetLifecyclePolicyQueryResult = ReturnType<typeof useGetProjectAssetLifecyclePolicyQuery>;

          
